export var SESSION_TYPES = {
    COURSE: 'course',
    SERVICE: 'service',
};
export var RATE_TYPES = {
    FIXED: 'fixed',
    VARIED: 'varied',
    NO_FEE: 'no_fee',
    CUSTOM: 'custom',
    UNKNOWN_RATE_TYPE: 'unknown_rate_type',
};
